import { render } from "./ShoppingCartPage.vue?vue&type=template&id=f85503f6"
import script from "./ShoppingCartPage.vue?vue&type=script&lang=js"
export * from "./ShoppingCartPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__